class measurementsContent extends HTMLElement {
  constructor() {
    super();
    this.getElements();
  }
  getElements() {
    let measurement_profiles_cookie = localStorage.getItem("measurement-profiles");
    let measurement_types_cookie = localStorage.getItem("measurement-types");
    let storage_date = new Date();
    if (measurement_profiles && measurement_types) {
      this.measurement_profiles = measurement_profiles;
      this.customerMeasurementProfiles = measurement_profiles.customerMeasurementProfiles;
      this.productTypes = measurement_profiles.productTypes;
      this.profileNames = measurement_profiles.profileNames;
      measurement_profiles['date-created'] = '' + storage_date.getTime();
      let measurement_profiles_param =  JSON.stringify(measurement_profiles);
      localStorage.setItem('measurement-profiles', measurement_profiles_param);

      this.measurement_types = measurement_types;
      this.guesstimates = measurement_types.guesstimates;
      this.measurementTypesData = measurement_types.measurementTypesData;
      measurement_types['date-created'] = '' + storage_date.getTime();
      let measurement_types_param =  JSON.stringify(measurement_types);
      var d1 = new Date();
      localStorage.setItem('measurement-types', measurement_types_param);
    }else if (measurement_profiles && !measurement_types) {
      this.measurement_profiles = measurement_profiles;
      this.customerMeasurementProfiles = measurement_profiles.customerMeasurementProfiles;
      this.productTypes = measurement_profiles.productTypes;
      this.profileNames = measurement_profiles.profileNames;
      measurement_profiles['date-created'] = '' + storage_date.getTime();
      let measurement_profiles_param =  JSON.stringify(measurement_profiles);
      localStorage.setItem('measurement-profiles', measurement_profiles_param);
      this.measurement_types = JSON.parse(measurement_types_cookie);
      this.guesstimates = this.measurement_types.guesstimates;
      this.measurementTypesData = this.measurement_types.measurementTypesData;
    }else if (!measurement_profiles && measurement_types) {
      this.measurement_profiles = JSON.parse(measurement_profiles_cookie);
      this.customerMeasurementProfiles = this.measurement_profiles.customerMeasurementProfiles;
      this.productTypes = this.measurement_profiles.productTypes;
      this.profileNames = this.measurement_profiles.profileNames;
      this.measurement_types = measurement_types;
      this.guesstimates = measurement_types.guesstimates;
      this.measurementTypesData = measurement_types.measurementTypesData;
      measurement_types['date-created'] = '' + storage_date.getTime();
      let measurement_types_param =  JSON.stringify(measurement_types);
      var d1 = new Date();
      localStorage.setItem('measurement-types', measurement_types_param);
    }else{
      this.measurement_profiles = JSON.parse(measurement_profiles_cookie);
      this.measurement_types = JSON.parse(measurement_types_cookie);
      this.customerMeasurementProfiles = this.measurement_profiles.customerMeasurementProfiles;
      this.productTypes = this.measurement_profiles.productTypes;
      this.profileNames = this.measurement_profiles.profileNames;
      this.guesstimates = this.measurement_types.guesstimates;
      this.measurementTypesData = this.measurement_types.measurementTypesData;
    }
    this.initElements();
  }
  initElements(){
    this.line_id = this.getAttribute('line_id');
    this.close_popup = document.querySelectorAll('.add-measurement-profile-wrap .close-popup');
    this.create_size = this.querySelectorAll('.item__measurement-create');
    this.add_new_btn = this.querySelectorAll('.add-profile-link');
    this.add_new_preset_btn = this.querySelectorAll('.add-preset-profile-link');
    this.edit_profile = this.querySelector('.edit-profile');
    this.edit_preset_profile = this.querySelector('.edit-preset-profile');
    this.customSelect = this.querySelector('.custom-select');
    this.initEvents();
    if(this.querySelector('.measure-loading-overlay')){
      this.querySelector('.measure-loading-overlay').classList.add('hidden');
    }

  }

  initEvents(){
    this.close_popup.forEach(btn => btn.addEventListener('click', this.closePopup.bind(this)));
    this.create_size.forEach(btn => btn.addEventListener('click', event => {
      event.preventDefault();
      event.currentTarget.parentElement.querySelector('.add-measurement-profile-wrap').classList.add("active");
      this.bodyFixed();
    }));
    this.add_new_btn.forEach(btn => findAncestor(btn, 'add-profile-block').addEventListener('click', this.createMeasurementProfileNew.bind(this)));
    this.add_new_preset_btn.forEach(btn => findAncestor(btn, 'add-profile-block').addEventListener('click', this.createMeasurementProfileNewPreset.bind(this)));
    if(this.edit_profile){
      this.edit_profile.addEventListener('click', this.createMeasurementProfileEdit.bind(this));
    }
    if(this.edit_preset_profile){
      this.edit_preset_profile.addEventListener('click', this.createMeasurementProfileEditPreset.bind(this));
    }
    if(this.customSelect){
      this.customSelect.addEventListener("click", this.openSelect.bind(this));
    }
  }
  measurePopupEvents(){
    let measure_popup = document.querySelector('.measure-profile-popup.active');
    this.close_definition_popup =  measure_popup.querySelectorAll('.close-definition-popup');
    this.open_converter =  measure_popup.querySelector('.converter .title-block');
    this.inputConverter = measure_popup.querySelector('.conver_num');
    this.resaultArea = measure_popup.querySelector('.result-converter');
    this.edit_height = measure_popup.querySelector('input.profile-option[data-optionname="Height"]');
    this.measurement_height = measure_popup.querySelectorAll('.height-option select');
    this.measurement_options = measure_popup.querySelectorAll('.profile-value-content');
    this.measurement_info = measure_popup.querySelectorAll('.info-block');
    this.valid_inputs = measure_popup.querySelectorAll('input[data-optiontype="float"]');
    this.bt_minus = measure_popup.querySelectorAll('.bt_minus');
    this.bt_plus = measure_popup.querySelectorAll('.bt_plus');
    this.prof_name = measure_popup.querySelectorAll('.measurement-profile-name');
    this.close_definition_popup.forEach(btn => btn.addEventListener('click', (event) => {
      event.preventDefault();
      measure_popup.querySelector('.profile-values-definition-wrap.active').classList.remove("active");
      measure_popup.classList.remove("info");
    }));
    if(this.open_converter){
      this.open_converter.addEventListener('click', (event) => {
        event.preventDefault();
        this.open_converter.parentElement.querySelector('.option-block').classList.toggle("active");
      });
    }
    if(this.inputConverter){
      this.inputConverter.addEventListener('input', this.converterCmtoInch.bind(this));
    }

    if(this.edit_height){
      let edit_height_val = this.edit_height.value;
      if(edit_height_val > 0){
        measure_popup.querySelector('#height-ft').value = (edit_height_val - (edit_height_val%12)) / 12;
        measure_popup.querySelector('#height-in').value = edit_height_val%12;
        measure_popup.querySelector('#height-ft').setAttribute("data-value", (edit_height_val - (edit_height_val%12)) / 12);
        measure_popup.querySelector('#height-in').setAttribute("data-value", edit_height_val%12);
      }
    }
    this.measurement_height.forEach(el => el.addEventListener('change', this.convertHeight.bind(this)));
    this.measurement_options.forEach(option => option.addEventListener("mousedown", (ev) => this.openDefinitionPopup(ev.currentTarget)));
    this.measurement_info.forEach(option => option.addEventListener('click', (ev) => this.openDefinitionPopup(ev.currentTarget)));
    this.valid_inputs.forEach(option => option.addEventListener("change", this.onInputValid.bind(this)));
    this.bt_minus.forEach(select => select.addEventListener('click', this.minusValues.bind(this)));
    this.bt_plus.forEach(select => select.addEventListener('click', this.plusValues.bind(this)));
    this.prof_name.forEach(select => select.addEventListener('input', (event) => {
      measure_popup.querySelector('.error-banner').innerText = "";
    }));
    let body = document.querySelector('body');
    body.addEventListener('keyup', this.checkTabPress.bind(this));

    let pasteBoxes = document.querySelectorAll(".profile-option");
    pasteBoxes.forEach(box => box.addEventListener('paste', (event) => {
      event.preventDefault();
      return false;
    }));
    this.prof_name.forEach(box => box.addEventListener('paste', (event) => {
      event.preventDefault();
      return false;
    }));
  }
  createMeasurementProfileNew(ev){
    let measure_id = ev.currentTarget.querySelector('.add-profile-link').getAttribute('data-id');
    let prof_opt = '';
    let measure_index = this.measurementTypesData.findIndex(p => p.measurementType.id == measure_id);
    let measurementType = this.measurementTypesData[measure_index].measurementType;
    let measurement_form_img;
    if (measurementType.role == 'body'){
      measurement_form_img = this.getAttribute('data-body-measurement-form-img');
    }else if(measurementType.role == 'garment'){
      measurement_form_img = this.getAttribute('data-garment-measurement-form-img');
    }
    let defaultProfileName;
    switch (measurementType.name) {
      case 'Jackets/Blazers':
        defaultProfileName = 'Jacket';
        break;
      case 'Waist Coat & Trouser Set':
        defaultProfileName = 'VestSet';
        break;
      default:
        defaultProfileName = measurementType.name;
        break;
    }

    function getDefinition(){
      var str = "";
      measurementType.measurements.forEach((measure, i) => {
        str += `<div class="definition-wrap ${i === 0 ? 'active' : ''}" data-option-type="${measure.name}">
                  <div class="measurement-profile-value-description">${measure.description}</div>`+
          (measure.imageURL != ''? `<img src="${measure.imageURL}" alt="${measure.name}">`:'')+
          `</div>`
      });
      return str;
    }
    function getOptions(min, max){
      var str = "";
      for(var i= min; i <= max; i++) {
        str+=`<option value="${i}">${i}</option>`;
      }
      return str;
    }

    function getDropdownVariants(variants){
      var str = "";
      variants.forEach((variant) => {
        str+= `<option ${(variant.isDefault)? 'selected' : ''} value="${variant.name}">${variant.name}</option>`
      })
      return str;
    }
    function getInputVariants(variants){
      var str = "";
      variants.forEach((variant) => {
        str+= `<input disabled class="profile-option" type="radio" name="values[][${variant.measurement.id}]" value="${variant.name}" data-optionName="${measure_data.measurement.name}">`
      })
      return str;
    }

    let cur_date = new Date();
    let newProfileName = defaultProfileName + "_" + ("0"+(cur_date.getMonth()+1)).slice(-2) + "/" + ("0" + cur_date.getDate()).slice(-2) + "/" + cur_date.getFullYear();

    if (this.profileNames.includes(newProfileName)) {
      let i = 0;
      let baseProfileName = newProfileName;
      do {
        i++;
        newProfileName = baseProfileName + '-' + i;
      } while (this.profileNames.includes(newProfileName));
    }

    measurementType.measurements.forEach((measure_data, i) =>{
      prof_opt += `<div class="measurement-profile-value" data-value-type="${measure_data.name}">\n
        <div class="profile-value-header">\n
          <h3 class="${measure_data.required ? 'required' : '' }">${measure_data.name}</h3>\n
          <span class="profile-value-header-note" data-optionName="${measure_data.name}"></span>\n
        </div>\n
        <div class="profile-value-content">`+
        ((measure_data.type == 'text' || measure_data.type == 'int' || measure_data.type == 'float' || measure_data.type == 'email')?
          ((measure_data.name.toLowerCase() == "height" )?
            `<div class="height-option">\n
                <div class="height-option-wrap">
                   <select class="profile-option reset height-ft" data-optionName="${measure_data.name}" name="ft" id="height-ft" ${measure_data.required ? 'required' : '' }>
                     <option disabled selected value>-</option>\n` +
            getOptions(measure_data.min/12, measure_data.max/12) +
            `</select>\n
                   <label for="height-ft">ft</label>\n
                   <select class="profile-option reset height-in" data-optionName="${measure_data.name}" name="in" id="height-in" ${measure_data.required ? 'required' : '' }>\n
                     <option>-</option>\n` +
            getOptions(measure_data.min % 12, measure_data.max % 12) +
            `</select>\n
                   <label for="height-in">in</label>\n
                </div>\n
                <div class="height-option-note info-block" data-optionName="${measure_data.name}">` +
            document.querySelector('.icons .icon-info').innerHTML +
            document.querySelector('.height-note-text').innerHTML +
            `</div>
              </div>\n`:'') +
          `<input class="editable-text profile-option ${measure_data.type == 'text' ? '' : 'reset' }" ${measure_data.type == 'text' ? 'onkeypress="return checkQuote();"' : '' } name="values[][${measure_data.id}]" type="text" ${measure_data.required && measure_data.name.toLowerCase() != "height" ? 'required' : '' } value=""
                 data-optionType="${measure_data.type}"
                 data-optionName="${measure_data.name}"
                 data-optionMin="${measure_data.min}"
                 data-optionMax="${measure_data.max}"
                 data-optionDecimalPoint="${measure_data.decimalPoint}" 
                 data-optionErrorMessage="${measure_data.errorMessage}"
                 ${measure_data.name.toLowerCase() == "height" ? 'tabindex="-1"' : ''}
                 ${measure_data.type == 'int' || measure_data.type == 'float' ? 'onkeypress="return isNumberKey(event)"' : '' }
                 ${measure_data.type == 'text' ? 'maxlength="100"' : '' }>\n`
          :
          (measure_data.type == 'dropdown')?
            `<select class="profile-option reset" data-optionName="${measure_data.name}" name="values[][${measure_data.id}]" ${measure_data.required ? 'required' : '' }>\n
                ${measure_data.hasDefault ? `<option disabled selected value>Select</option>` : '' }`
            + getDropdownVariants(measure_data.variants) +
            `</select>\n`
            :
            + getInputVariants(measure_data.variants)) +
        (measure_data.name.toLowerCase() != "height" ?
          (measure_data.description !='' || measure_data.imageURL !='')? `<div class="info-block" data-optionName="${measure_data.name}">`+ document.querySelector('.icons .icon-info').innerHTML + `</div>` : ''
          : '')+
        `</div>
          <div class="validation-note-wrap">
            <span class="validation-note validation-note-range">Range ${measure_data.min}-${measure_data.max} inches</span>
            <span class="validation-note validation-note-required">This Field cannot be empty</span>
            <span class="validation-note validation-note-incorrect">Incorrect value</span>
          </div>
      </div>`
    });

    let add_new_data = `<div class="measurement-new-profile measurement-profile-options" data-id="${measure_id}">
    <h1 class="profile-title">Create a ${measurementType.name} Size Profile</h1>
    <form id="measurement-new-profile" name="measurement-new-profile" enctype="multipart/form-data" class="profile-form">
        <input name="measurementTypeId" type="hidden" value="${measurementType.id}">
        <input name="measurementTypeRole" type="hidden" value="${measurementType.role}">
        <input name="customerApiId" type="hidden" value="${customer_id}">
        <div class="back-block">
          <span>` + document.querySelector('.translators .back-text').innerHTML + `</span>
          <div class="back-block-btn">
                <button type="button" class="reset-btn">Reset</button>
            </div>
            <div class="printable_form">
            <a href="${measurement_form_img}" target="_blank">`+ document.querySelector('.icons .icon-print').innerHTML + `<span>Print</span></a>
            </div> 
        </div>
        <div class="profile-form-content">
            <div class="option-form">
                <div class="form converter">
                    <div class="title-block">`
      + document.querySelector('.icons .icon-calc').innerHTML +
      `<p>Unit: Inches <span class="title-block-note">[Cm to Inch Converter]</span></p>
                    </div>
                    <div class="option-block">
                        <label><input class="conver_num" type="text" min="0" onkeypress="return isNumberKey(event)" placeholder="CM =" maxlength="4"></label>
                        <div class="result-wrapper"><span class="result-converter">INCH</span></div>
                    </div>
                </div>`+
      prof_opt +
      `<div class="profile-name measurement-profile-value">
                 <h3 class="required">Measurement profile name: <span class="pf-name-note">` + document.querySelector('.icons .icon-info').innerHTML + `<span class="pf-name-tooltip">` + document.querySelector('.profile-name-note').innerHTML + `</span></span></h3>
                 <input id="measurement-profile-name" onkeypress="return checkQuote();" class="measurement-profile-name" name="name" type="text" value="${newProfileName}" maxlength="100" required>
                 <span class="validation-note validation-note-required">This Field cannot be empty</span>
               </div>
               <div class="measurement-profile-values profile-values-btn">
                  <div class="error-banner"></div>
                  <div class="edit-btn">
                     <button type="button" class='form-submit button'>Save</button>
                   </div>
              </div>
            </div>
            <div class="profile-values-definition-wrap">
              <div class="profile-values-definition"><div class="profile-values-definition-info">` +
      getDefinition() +
      `</div><button type="button" class="close-definition-popup">Close</button>
              </div>
            </div>
        </div>
        </form>
    </div>`
    document.querySelector('.new-measure-profile-content').innerHTML = add_new_data;
    if(document.querySelector('.add-measurement-profile-wrap.active')){
      document.querySelector('.add-measurement-profile-wrap.active').classList.remove('active');
      this.bodyRemoveFixed();
    }
    this.showPopup();
    document.querySelector('.new-measure-profile').classList.add('active');
    this.measurePopupEvents();
    this.saveNewMeasure();
  }
  createMeasurementProfileNewPreset(ev){
    let measure_id = ev.currentTarget.querySelector('.add-preset-profile-link').getAttribute('data-id');
    let add_presize_prof = '';
    let presize_options = '';
    let presize_definition = '';
    let measure_index = this.measurementTypesData.findIndex(p => p.measurementType.id == measure_id);
    let measurementData = this.measurementTypesData[measure_index];
    let measurementType = this.measurementTypesData[measure_index].measurementType;
    let pre_sets = measurementData.preSets;
    let normalizedOptions = {};
    let presetConditions = [];
    let presetValues = [];
    let optionNickNameToName = [];
    pre_sets.forEach((preset) => {
      let presetCondition = {};
      presetCondition['id'] = preset.id;
      preset.optionValues.forEach((optionValue,i) => {
        if(optionValue.optionNickname){
          optionNickNameToName[optionValue.optionNickname] = optionValue.optionName;
        }
        presetCondition[optionValue.optionNickname] = optionValue.value;
        if(!normalizedOptions[optionValue.optionNickname] || !normalizedOptions[optionValue.optionNickname].includes(optionValue.value)){
          if(!normalizedOptions[optionValue.optionNickname]){
            normalizedOptions[optionValue.optionNickname] = [];
          }
          normalizedOptions[optionValue.optionNickname].push(optionValue.value);
        }
      });
      presetConditions.push(presetCondition);
      presetValues[preset.id] = preset.values;
    })

    let defaultProfileName;
    switch (measurementType.name) {
      case 'Jackets/Blazers':
        defaultProfileName = 'Jacket';
        break;
      case 'Waist Coat & Trouser Set':
        defaultProfileName = 'VestSet';
        break;
      default:
        defaultProfileName = measurementType.name;
        break;
    }
    function getDropdownVariants(variants){
      var str = "";
      variants.forEach((variant) => {
        str+= `<option>${variant.name}</option>`
      })
      return str;
    }
    function getInputVariants(variants){
      var str = "";
      variants.forEach((variant) => {
        str+= `<input disabled class="profile-option" type="radio" name="values[][${variant.measurement.id}]" value="${variant.name}" data-optionName="${measure_data.measurement.name}">`
      })
      return str;
    }

    let cur_date = new Date();
    let newProfileName = defaultProfileName + "_" + ("0"+(cur_date.getMonth()+1)).slice(-2) + "/" + ("0" + cur_date.getDate()).slice(-2) + "/" + cur_date.getFullYear();

    if (this.profileNames.includes(newProfileName)) {
      let i = 0;
      let baseProfileName = newProfileName;
      do {
        i++;
        newProfileName = baseProfileName + '-' + i;
      } while (this.profileNames.includes(newProfileName));
    }
    function getOptionValues(option_values){
      var str = "";
      option_values.forEach((value) => {
        str+= `<option>${value}</option>`
      })
      return str;
    }

    for (var option in normalizedOptions) {
      let option_values = normalizedOptions[option];
      presize_options += `<div class="select-preset-wrap">
          <h3>Select ${optionNickNameToName[option] ? optionNickNameToName[option] : option}</h3>
          <select id="${option}" name="${option}" class="select-preset not-select">
             <option disabled selected value>Select</option>`+
        getOptionValues(option_values) +
        `</select>
          </div>`
    }

    measurementType.measurements.forEach((measure_data, i) =>{
      add_presize_prof += `<div class="measurement-profile-value" data-value-type="${measure_data.name}">\n
        <div class="profile-value-header">\n
          <h3 class="${measure_data.required ? 'required' : '' }">${measure_data.name}</h3>\n
          <span class="profile-value-header-note" data-optionName="${measure_data.name}"></span>\n
        </div>\n
        <div class="profile-value-content">`+
        (measure_data.name.toLowerCase() != "height" ?
          (measure_data.description !='' || measure_data.imageURL !='')? `<div class="info-block" data-optionName="${measure_data.name}">`+ document.querySelector('.icons .icon-info').innerHTML + `</div>` : ''
          : '')+
        ((measure_data.type == 'text' )?
            `<input class="editable-text profile-option" onkeypress="return checkQuote();" name="values[][${measure_data.id}]" maxlength="100" type="text" ${measure_data.required ? 'required' : ''} value=""
                   data-optionType="${measure_data.type}"
                   data-optionName="${measure_data.name}"
                   data-optionMin="${measure_data.min}"
                   data-optionMax="${measure_data.max}"
                   data-optionDecimalPoint="${measure_data.decimalPoint}" 
                   data-optionErrorMessage="${measure_data.errorMessage}"
              >\n`:
            ((measure_data.type == 'int' || measure_data.type == 'float' || measure_data.type == 'email')?
              `<div class="quantity_inner">
                   <span class="bt_minus disabled ${measure_data.name.toLowerCase().indexOf('outseam') > -1 ? 'auto' : ''}">-</span>
                   <input class="editable-text profile-option reset disabled" name="values[][${measure_data.id}]" type="text" ${measure_data.required ? 'required' : ''} value="0.0"
                         data-optionType="${measure_data.type}"
                         data-optionName="${measure_data.name}"
                         data-optionMin="${measure_data.min}"
                         data-optionMax="${measure_data.max}"
                         data-optionDecimalPoint="${measure_data.decimalPoint}" 
                         data-optionErrorMessage="${measure_data.errorMessage}"
                        ${measure_data.type == 'int' || measure_data.type == 'float' ? 'onkeypress="return isNumberKey(event)"' : '' }
                   >
                   <span class="bt_plus disabled ${measure_data.name.toLowerCase().indexOf('outseam') > -1 ? 'auto' : ''}">+</span>
                </div>\n`
              :
              (measure_data.type == 'dropdown')?
                `<select class="profile-option reset" data-optionName="${measure_data.name}" name="values[][${measure_data.id}]" >\n`
                + getDropdownVariants(measure_data.variants) +
                `</select>\n`
                :
                + getInputVariants(measure_data.variants))
        ) +
        `<div class="validation-note-wrap">
              <span class="validation-note validation-note-required">This Field cannot be empty</span>
              <span class="validation-note validation-note-incorrect">Incorrect value</span>
          </div>
        </div>
      </div>`

      presize_definition += `<div class="definition-wrap ${i === 0 ? 'active' : ''}" data-option-type="${measure_data.name}">
         <div class="measurement-profile-value-description">${measure_data.description}</div>`+
        (measure_data.imageURL != ''? `<img src="${measure_data.imageURL}" alt="${measure_data.name}">` : '')+
        `</div>`
    });

    let add_new_prisize_data = `<div class="measurement-new-profile measurement-profile-options preset-profile">
      <h1 class="profile-title">Create a ${measurementType.name} Size Profile</h1>
      <form id="measurement-new-profile" name="measurement-new-profile" enctype="multipart/form-data" class="profile-form">
          <input name="measurementTypeId" type="hidden" value="${measurementType.id}">
          <input name="measurementTypeRole" type="hidden" value="${measurementType.role}">
          <input name="customerApiId" type="hidden" value="${customer_id}">
          <input id="initialPresetId" name="initialPresetId" type="hidden" value="">
          <input id="secondaryInitialPresetId" name="secondaryInitialPresetId" type="hidden" value="">
          <div class="back-block">
            <span>` + document.querySelector('.translators .preset-back-text').innerHTML + `</span>
            <div class="back-block-btn">
                <button type="button" class="reset-btn">Reset</button>
            </div>
          </div>
          <div class="profile-form-content">
            <div class="preset-sizes-wrap">
              <h2>${measurementType.name} Size</h2>` +
      presize_options +
      `<div class="profile-values-definition-wrap">
                 <div class="profile-values-definition"><div class="profile-values-definition-info">`+
      presize_definition +
      `</div><button type="button" class="close-definition-popup">Close</button>
                 </div>
              </div>
            </div>
            <div class="option-form">
               <h2>${measurementType.name}  Size Details</h2>`+
      add_presize_prof +
      `<div class="profile-name measurement-profile-value">
                 <h3 class="required">Measurement profile name: <span class="pf-name-note">` + document.querySelector('.icons .icon-info').innerHTML + `<span class="pf-name-tooltip">` + document.querySelector('.profile-name-note').innerHTML + `</span></span></h3>
                 <input id="measurement-profile-name" onkeypress="return checkQuote();" class="measurement-profile-name" name="name" type="text" value="${newProfileName}" maxlength="100" required>
                 <span class="validation-note validation-note-required">This Field cannot be empty</span>
              </div>
               <div class="measurement-profile-values profile-values-btn">
                  <div class="error-banner"></div>
                  <div class="edit-btn">
                     <button type="button" class='form-submit button'>Save</button>
                  </div>
               </div>
             </div>
          </div>
      </form>
    </div>`
    document.querySelector('.new-presize-measure-profile-content').innerHTML = add_new_prisize_data;
    if(document.querySelector('.add-measurement-profile-wrap.active')){
      document.querySelector('.add-measurement-profile-wrap.active').classList.remove('active');
      this.bodyRemoveFixed();
    }
    this.showPopup();
    document.querySelector('.new-presize-measure-profile').classList.add('active');
    this.measurePopupEvents();
    this.saveNewPresizeMeasure(measurementType,presetConditions,presetValues);
  }
  createMeasurementProfileEdit(ev){
    let measure_id = ev.currentTarget.getAttribute('data-measure-id');
    let prof_opt = '';
    let measure_index = this.customerMeasurementProfiles.findIndex(p => p.id == measure_id);
    let measurementType = this.customerMeasurementProfiles[measure_index];

    function getDefinition(){
      var str = "";
      measurementType.values.forEach((measure, i) => {
        str += `<div class="definition-wrap ${i === 0 ? 'active' : ''}" data-option-type="${measure.measurement.name}">
                  <div class="measurement-profile-value-description">${measure.measurement.description}</div>`+
          (measure.measurement.imageURL != ''? `<img src="${measure.measurement.imageURL}" alt="${measure.measurement.name}">`:'')+
          `</div>`
      });
      return str;
    }
    function getOptions(min, max){
      var str = "";
      for(var i= min; i <= max; i++) {
        str+=`<option value="${i}">${i}</option>`;
      }
      return str;
    }

    function getDropdownVariants(measure_data){
      let selected_var = false;
      let str = "";
      measure_data.measurement.variants.forEach((variant) => {
        if(variant.name == measure_data.value){
          selected_var = true;
        }
        str+= `<option class="${(variant.name == measure_data.value)? 'default' : ''}" ${(variant.name == measure_data.value)? 'selected' : ''} value="${variant.name}">${variant.name}</option>`
      })
      if(!selected_var){
        str = '<option value disabled selected>Select value</option>' + str;
      }
      return str;
    }
    function getInputVariants(measure_data){
      var str = "";
      measure_data.measurement.variants.forEach((variant) => {
        str+= `<input class="profile-option reset" ${(measure_data.measurement.required) ? 'required' : '' } type="radio" name="values[][${variant.measurement.id}]" value="${variant.name}" data-optionName="${measure_data.measurement.name}">`
      })
      return str;
    }

    measurementType.values.forEach((measure_data, i) =>{
      prof_opt += `<div class="measurement-profile-value" data-value-type="${measure_data.measurement.name}">\n
        <div class="profile-value-header">\n
          <h3 class="${measure_data.measurement.required ? 'required' : '' }">${measure_data.measurement.name}</h3>\n
          <span class="profile-value-header-note" data-optionName="${measure_data.measurement.name}"></span>\n
        </div>\n
        <div class="profile-value-content">`+
        ((measure_data.measurement.type == 'text' || measure_data.measurement.type == 'int' || measure_data.measurement.type == 'float' || measure_data.measurement.type == 'email')?
          ((measure_data.measurement.name == "Height" )?
            `<div class="height-option">\n
                <div class="height-option-wrap">
                   <select class="profile-option reset height-ft" data-optionName="${measure_data.measurement.name}" name="ft" id="height-ft" ${measure_data.measurement.required ? 'required' : '' }>` +
            getOptions(4, 7) +
            `</select>\n
                   <label for="height-ft">ft</label>\n
                   <select class="profile-option reset height-in" data-optionName="${measure_data.measurement.name}" name="in" id="height-in" ${measure_data.measurement.required ? 'required' : '' }>` +
            getOptions(0, 11) +
            `</select>\n
                   <label for="height-in">in</label>\n
                </div>\n
                <div class="height-option-note info-block" data-optionName="${measure_data.measurement.name}">` +
            document.querySelector('.icons .icon-info').innerHTML +
            document.querySelector('.height-note-text').innerHTML +
            `</div>
              </div>\n`:'') +
          `<input class="editable-text profile-option ${measure_data.measurement.type == 'text' ? '' : 'reset' }" 
                 ${measure_data.measurement.type == 'text' ? 'onkeypress="return checkQuote();"' : '' } 
                 data-value="${measure_data.value && measure_data.value != "null" ? measure_data.value : '' }" name="values[][${measure_data.measurement.id}]" 
                 type="text" ${(measure_data.measurement.required && measure_data.measurement.name.toLowerCase() != "height") ? 'required' : '' } 
                 value="${measure_data.value && measure_data.value != "null" ? measure_data.value : '' }"
                 data-optionType="${measure_data.measurement.type}"
                 data-optionName="${measure_data.measurement.name}"
                 data-optionMin="${measure_data.measurement.min}"
                 data-optionMax="${measure_data.measurement.max}"
                 data-optionDecimalPoint="${measure_data.measurement.decimalPoint}" 
                 data-optionErrorMessage="${measure_data.measurement.errorMessage}"
                 ${measure_data.measurement.name.toLowerCase() == "height" ? 'tabindex="-1"' : ''}
                 ${measure_data.measurement.type == 'int' || measure_data.measurement.type == 'float' ? 'onkeypress="return isNumberKey(event)"' : '' }
                 ${measure_data.measurement.type == 'text' ? 'maxlength="100"' : '' }>\n`
          :
          (measure_data.measurement.type == 'dropdown')?
            `<select class="profile-option reset" ${(measure_data.measurement.required) ? 'required' : '' }  data-optionName="${measure_data.measurement.name}" name="values[][${measure_data.measurement.id}]">\n`
            + getDropdownVariants(measure_data) +
            `</select>\n`
            :
            + getInputVariants(measure_data)) +
        (measure_data.measurement.name.toLowerCase() != "height" ?
          (measure_data.measurement.description !='' || measure_data.measurement.imageURL !='')? `<div class="info-block" data-optionName="${measure_data.measurement.name}">`+ document.querySelector('.icons .icon-info').innerHTML + `</div>` : ''
          : '')+
        `</div>
          <div class="validation-note-wrap">
            <span class="validation-note validation-note-range">Range ${measure_data.measurement.min}-${measure_data.measurement.max} inches</span>
            <span class="validation-note validation-note-required">This Field cannot be empty</span>
            <span class="validation-note validation-note-incorrect">Incorrect value</span>
          </div>
      </div>`
    });

    let edit_data = `<div class="measurement-edit-profile measurement-profile-options" data-id="${measure_id}">
      <h1 class="profile-title">Edit ${measurementType.name}</h1>
      <form id="measurement-edit-profile" class="profile-form" name="measurement-edit-profile" enctype="multipart/form-data">
          <input name="customerApiId" type="hidden" value="${customer_id}">
          <input name="measurementTypeProfileId" type="hidden" value="${measure_id}">
          <input name="measurementTypeId" type="hidden" value="${measurementType.measurementTypeId}">
          <input name="measurementTypeRole" type="hidden" value="${measurementType.measurementTypeRole}">
          <div class="back-block">
            <span>` + document.querySelector('.translators .back-text').innerHTML + `</span>
            <div class="back-block-btn">
                <button type="button" class="reset-btn">Reset</button>
            </div>
          </div>
          <div class="profile-form-content">
              <div class="option-form">
                  <div class="form converter">
                      <div class="title-block">`
      + document.querySelector('.icons .icon-calc').innerHTML +
      `<p>Unit: Inches <span class="title-block-note">[Cm to Inch Converter]</span></p>
                      </div>
                      <div class="option-block">
                          <label><input class="conver_num" type="text" min="0" onkeypress="return isNumberKey(event)" placeholder="CM =" maxlength="4"></label>
                          <div class="result-wrapper"><span class="result-converter">INCH</span></div>
                      </div>
                  </div>`+
      prof_opt +
      `<div class="profile-name measurement-profile-value">
                   <h3 class="required">Measurement profile name: <span class="pf-name-note">` + document.querySelector('.icons .icon-info').innerHTML + `<span class="pf-name-tooltip">` + document.querySelector('.profile-name-note').innerHTML + `</span></span></h3>
                   <input id="measurement-profile-name" onkeypress="return checkQuote();" name="name" class="measurement-profile-name" type="text" value="${measurementType.name}" maxlength="100" required>
                   <span class="validation-note validation-note-required">This Field cannot be empty</span>
                 </div>
                 <div class="measurement-profile-values profile-values-btn">
                    <div class="error-banner"></div>
                    <div class="edit-btn">
                       <button type="button" class='button update_form' id="update_form">Update</button>
                       <button type="button"  class='button save_form' id="save_form" data-name="${measurementType.name}">Save as New</button>
                     </div>
                </div>
              </div>
              <div class="profile-values-definition-wrap">
                <div class="profile-values-definition"><div class="profile-values-definition-info">` +
      getDefinition() +
      `</div><button type="button" class="close-definition-popup">Close</button>
                </div>
              </div>
          </div>
      </form>
    </div>`
    document.querySelector('.edit-measure-profile-content').innerHTML = edit_data;
    this.showPopup();
    document.querySelector('.edit-measure-profile').classList.add('active');
    this.measurePopupEvents();
    this.editProfileEvents();
  }
  createMeasurementProfileEditPreset(ev){
    let measure_id = ev.currentTarget.getAttribute('data-measure-id');
    let add_presize_prof = '';
    let presize_options = '';
    let presize_definition = '';
    let measure_index = this.customerMeasurementProfiles.findIndex(p => p.id == measure_id);
    let measurementType = this.customerMeasurementProfiles[measure_index];
    let measure_index_preset = this.measurementTypesData.findIndex(p => p.measurementType.id == measurementType.measurementTypeId);
    let initialPresetId = measurementType.initialPresetId;
    let secondaryInitialPresetId = measurementType.secondaryInitialPresetId;
    let pre_sets_id = this.measurementTypesData[measure_index_preset].preSets.findIndex(p => p.id == initialPresetId);
    let pre_sets = this.measurementTypesData[measure_index_preset].preSets[pre_sets_id];
    let presetValues = [];

    pre_sets.values.forEach((preset) => {
      presetValues[preset.name] = preset.value;
    })

    if(secondaryInitialPresetId){
      let secondary_pre_sets_id = this.measurementTypesData[measure_index_preset].preSets.findIndex(p => p.id == secondaryInitialPresetId);
      let secondary_pre_sets = this.measurementTypesData[measure_index_preset].preSets[secondary_pre_sets_id];
      secondary_pre_sets.values.forEach((preset) => {
        presetValues[preset.name] = preset.value;
      })
    }
    function getDropdownVariants(measure_data){
      let selected_var = false;
      let str = "";
      measure_data.measurement.variants.forEach((variant) => {
        if(variant.name == measure_data.value){
          selected_var = true;
        }
        str+= `<option class="${(variant.name == measure_data.value)? 'default' : ''}" ${(variant.name == measure_data.value)? 'selected' : ''} value="${variant.name}">${variant.name}</option>`
      })
      if(!selected_var){
        str = '<option value disabled selected>Select value</option>' + str;
      }
      return str;
    }
    function getInputVariants(measure_data){
      var str = "";
      measure_data.measurement.variants.forEach((variant) => {
        str+= `<input class="profile-option reset" ${(measure_data.measurement.required) ? 'required' : '' } type="radio" name="values[][${variant.measurement.id}]" value="${variant.name}" data-optionName="${measure_data.measurement.name}">`
      })
      return str;
    }

    measurementType.values.forEach((measure_data, i) =>{
      let minValue;
      let maxValue;
      if(presetValues[measure_data.measurement.name] && !isNaN(presetValues[measure_data.measurement.name])){
        if (measure_data.measurement.min && measure_data.measurement.min != '' && isNaN(measure_data.measurement.min) && measure_data.measurement.min != 0) {
          minValue = Math.max(presetValues[measure_data.measurement.name]-2, measure_data.measurement.min);
        } else {
          minValue = presetValues[measure_data.measurement.name]-2;
        }
        if (measure_data.measurement.max && measure_data.measurement.max != '' && isNaN(measure_data.measurement.max) && measure_data.measurement.max != 0) {
          maxValue = Math.min(+(presetValues[measure_data.measurement.name])+2, measure_data.measurement.max);
        } else {
          maxValue = +(presetValues[measure_data.measurement.name]) + 2;
        }
      } else {
        minValue = measure_data.measurement.min;
        maxValue = measure_data.measurement.max;
      }
      add_presize_prof += `<div class="measurement-profile-value" data-value-type="${measure_data.measurement.name}">\n
        <div class="profile-value-header">\n
          <h3 class="${measure_data.measurement.required ? 'required' : '' }">${(measure_data.measurement.name).replace('~', '')}</h3>\n
          <span class="profile-value-header-note" data-optionName="${measure_data.measurement.name}"></span>\n
        </div>\n
        <div class="profile-value-content" data-value-type="${measure_data.measurement.type}">`+
        (measure_data.measurement.name.toLowerCase() != "height" ?
          (measure_data.measurement.description !='' || measure_data.measurement.imageURL !='')? `<div class="info-block" data-optionName="${measure_data.measurement.name}">`+ document.querySelector('.icons .icon-info').innerHTML + `</div>` : ''
          : '')+
        ((measure_data.measurement.type == 'text' )?
            `<input class="editable-text profile-option" name="values[][${measure_data.measurement.id}]" onkeypress="return checkQuote();" maxlength="100" type="text" value="${measure_data.value && measure_data.value != "null" ? measure_data.value : '' }" ${measure_data.measurement.required ? 'required' : ''}
                   data-optionType="${measure_data.measurement.type}"
                   data-optionName="${measure_data.measurement.name}"
                   data-optionMin="${minValue}"
                   data-optionMax="${maxValue}"
                   data-optionDecimalPoint="${measure_data.measurement.decimalPoint}" 
                   data-optionErrorMessage="${measure_data.measurement.errorMessage}"
                   ${measure_data.measurement.name.toLowerCase() == "height" ? 'tabindex="-1"' : ''}
              >\n`:
            ((measure_data.measurement.type == 'int' || measure_data.measurement.type == 'float' || measure_data.measurement.type == 'email')?
              `<div class="quantity_inner">
                   <span class="bt_minus ${measure_data.measurement.name.toLowerCase().indexOf('outseam') > -1 ? 'disabled auto' : ''} ${measure_data.value <= minValue ? 'disabled default-disabled' : ''}">-</span>
                   <input class="editable-text profile-option reset disabled" 
                         name="values[][${measure_data.measurement.id}]" 
                         type="text" 
                         ${measure_data.measurement.required ? 'required' : ''} 
                         value="${measure_data.value && measure_data.value != "null" ? measure_data.value : 0 }"
                         data-optionType="${measure_data.measurement.type}"
                         data-optionName="${measure_data.measurement.name}"
                         data-optionMin="${minValue}"
                         data-optionMax="${maxValue}"
                         data-optionDecimalPoint="${measure_data.measurement.decimalPoint}" 
                         data-optionErrorMessage="${measure_data.measurement.errorMessage}"
                         data-value="${measure_data.value && measure_data.value != "null" ? measure_data.value : 0 }"
                        ${measure_data.measurement.type == 'int' || measure_data.measurement.type == 'float' ? 'onkeypress="return isNumberKey(event)"' : '' }
                   >
                   <span class="bt_plus ${measure_data.measurement.name.toLowerCase().indexOf('outseam') > -1 ? 'disabled auto' : ''} ${measure_data.value == maxValue ? 'disabled default-disabled' : ''}">+</span>
                </div>\n`
              :
              (measure_data.measurement.type == 'dropdown')?
                `<select class="profile-option" ${measure_data.measurement.required ? 'required' : ''} data-optionName="${measure_data.measurement.name}" name="values[][${measure_data.measurement.id}]" >\n`
                + getDropdownVariants(measure_data) +
                `</select>\n`
                :
                + getInputVariants(measure_data))
        ) +
        `<div class="validation-note-wrap">
              <span class="validation-note validation-note-required">This Field cannot be empty</span>
              <span class="validation-note validation-note-incorrect">Incorrect value</span>
          </div>
        </div>
      </div>`

      presize_definition += `<div class="definition-wrap ${i === 0 ? 'active' : ''}" data-option-type="${measure_data.measurement.name}">
         <div class="measurement-profile-value-description">${measure_data.measurement.description}</div>`+
        (measure_data.measurement.imageURL != ''? `<img src="${measure_data.measurement.imageURL}" alt="${measure_data.measurement.name}">` : '')+
        `</div>`
    });

    let edit_data = `<div class="measurement-new-profile measurement-profile-options preset-profile edit-preset-profile" data-id="${measure_id}">
      <h1 class="profile-title">Edit  ${measurementType.name}</h1>
      <form id="measurement-edit-profile" class="profile-form" name="measurement-edit-profile" enctype="multipart/form-data">
          <div class="back-block">
            <span>` + document.querySelector('.translators .preset-back-text').innerHTML + `</span>
            <div class="back-block-btn">
                <button type="button" class="reset-btn">Reset</button>
            </div>
          </div>
          <input name="customerApiId" type="hidden" value="${customer_id}">
          <input name="measurementTypeProfileId" type="hidden" value="${measure_id}">
          <input name="measurementTypeId" type="hidden" value="${measurementType.measurementTypeId}">
          <input name="measurementTypeRole" type="hidden" value="${measurementType.measurementTypeRole}">
          <input id="initialPresetId" name="initialPresetId" type="hidden" value="${(measurementType.initialPresetId)?measurementType.initialPresetId : ''}">
          <input id="secondaryInitialPresetId" name="secondaryInitialPresetId" type="hidden" value="${(measurementType.secondaryInitialPresetId)?measurementType.secondaryInitialPresetId : ''}">
          <div class="profile-form-content">
            <div class="option-form">
               <h2>${measurementType.name}  Size Details</h2>`+
      add_presize_prof +
      `<div class="profile-name measurement-profile-value">
                 <h3 class="required">Edit profile name: <span class="pf-name-note">` + document.querySelector('.icons .icon-info').innerHTML + `<span class="pf-name-tooltip">` + document.querySelector('.profile-name-note').innerHTML + `</span></span></h3>
                 <input id="measurement-profile-name" onkeypress="return checkQuote();" class="measurement-profile-name" name="name" type="text" value="${measurementType.name}" maxlength="100" required>
                 <span class="validation-note validation-note-required">This Field cannot be empty</span>
               </div>
               <div class="measurement-profile-values profile-values-btn active">
                  <div class="error-banner"></div>
                  <div class="edit-btn">
                     <button type="button" class='button update_form' id="update_form">Update</button>
                     <button type="button"  class='button save_form' id="save_form" data-name="${measurementType.name}">Save as New</button>
                  </div>
               </div>
            </div>
            <div class="preset-sizes-wrap">
               <div class="profile-values-definition-wrap">
                 <div class="profile-values-definition"><div class="profile-values-definition-info">`+
      presize_definition +
      `</div><button type="button" class="close-definition-popup">Close</button>
                 </div>
              </div>
            </div>
          </div>  
      </form>
    </div>`
    document.querySelector('.edit-presize-measure-profile-content').innerHTML = edit_data;
    this.showPopup();
    document.querySelector('.edit-presize-measure-profile').classList.add('active');
    this.measurePopupEvents();
    this.editPresetsProfileEvents();
  }
  saveNewMeasure(){
    let formElement = document.querySelector('.measure-profile-popup.active #measurement-new-profile');
    let $this = this;
    let inputs = formElement.querySelectorAll('.editable-text');
    for (let i = 0; i < inputs.length; i++) {
      inputs[i].addEventListener('change', this.tryToGuesstimate.bind(this), false);
    }

    formElement.addEventListener('change', () => {
      formChanged = true;
    });
    formElement.querySelectorAll('.reset').forEach(el=>el.addEventListener('change', () => {
      formElement.querySelector('.reset-btn').classList.add("active");
    }));
    formElement.querySelector('.reset-btn').addEventListener('click', resetValues);
    function resetValues(){
      formElement.querySelectorAll('input.reset').forEach(el=>el.value = '');
      formElement.querySelectorAll('select').forEach(el=>el.selectedIndex = 0);
      formElement.querySelector('.reset-btn').classList.remove("active");
      formElement.querySelectorAll('.validation-note').forEach(el=>el.classList.remove("active"));
      formElement.querySelectorAll('.profile-value-header-note').forEach(el=>el.innerHTML = "");
    };
    function formValidation(event){
      event.preventDefault();
      formElement.querySelectorAll('.validation-note-required').forEach(el=>el.classList.remove("active"));
      for(var i=0; i < formElement.elements.length; i++){
        var parent = findAncestor(formElement.elements[i], 'measurement-profile-value');
        if(parent){
          if(formElement.elements[i].value === '' && formElement.elements[i].hasAttribute('required')){
            parent.querySelector('.validation-note-required').classList.add("active");
            $this.scrollToError(parent);
            return false;
          }else if(formElement.elements[i].value === 'null' || formElement.elements[i].value === null){
            parent.querySelector('.validation-note-incorrect').classList.add("active");
            $this.scrollToError(parent);
            return false;
          }else if(parent.querySelector('.validation-note-range.active')){
            $this.scrollToError(parent);
            return false;
          }
        }
      }
      if(formElement.querySelectorAll('.validation-note.active').length > 0){
        return false;
      }else{
        let current_name = formElement.querySelector('.measurement-profile-name').value;
        if(!$this.profileNames.includes(current_name)){
          submitForm();
        }else{
          formElement.querySelector('.error-banner').innerText = "Duplicate Profile Name Alert, Please enter a new unique profile name!";
        }
      }
    };
    function submitForm(){
      formElement.querySelector('.form-submit').classList.add('loading');
      formElement.querySelector('.form-submit').setAttribute('disabled', true);
      formElement.classList.add('loading');
      const formData = getFormJSON(formElement);
      formData['values'] = formData['values'].map((el) => ({'measurementId': el.id, 'value': el.value}));
      fetch('/apps/app-proxy/addCustomerMeasurementTypeProfile',
        {
          method: 'POST',
          body: JSON.stringify(formData)
        }
      ).then(response => response.json()).then(response => {
        if (response.success) {
          formChanged = false;
          $this.mergeNewProfiles(response);
        } else {
          formElement.classList.remove('loading');
          formElement.querySelector('.form-submit').classList.remove('loading');
          formElement.querySelector('.form-submit').removeAttribute('disabled');
          formElement.querySelector('.error-banner').innerText = response.message;
        }
      });
    }
    formElement.querySelector('.form-submit').addEventListener('click', formValidation);
  }
  saveNewPresizeMeasure(measurementType,presetConditions,presetValues){
    formChanged = false;
    let $this = this;
    const preset_container = document.querySelector('.measure-profile-popup.active');
    const fillPresetValues = (e) => {
      e.currentTarget.classList.remove('not-select');
      const presetSelectors = preset_container.querySelectorAll('.select-preset-wrap .select-preset');
      const selectedConditions = {};
      if (presetSelectors.length > 0) {
        presetSelectors.forEach(selector => {
          selectedConditions[selector.name] = selector.value;
        });
      }

      let matchedPreset = [];
      let initialPresetId = null;

      if(measurementType.productType == "Suits"){
        const jacketPartIds = presetConditions.filter(presetElement => {
          return presetElement['size'] === selectedConditions['size'] && presetElement['fit'] === selectedConditions['fit'];
        });

        const trouserPartIds = presetConditions.filter(presetElement => {
          return presetElement['waist'] === selectedConditions['waist'] && presetElement['inseam'] === selectedConditions['inseam'];
        });

        if (jacketPartIds.length) {
          matchedPreset = matchedPreset.concat(presetValues[jacketPartIds[0].id]);
          initialPresetId = jacketPartIds[0].id;
          preset_container.querySelector('#initialPresetId').value = initialPresetId;
        }
        if (trouserPartIds.length) {
          matchedPreset = matchedPreset.concat(presetValues[trouserPartIds[0].id]);
          preset_container.querySelector('#secondaryInitialPresetId').value = trouserPartIds[0].id;
        }
        if (jacketPartIds.length && trouserPartIds.length) {
          preset_container.querySelector('.profile-values-btn').classList.add('active');
        }
      }else{
        const filteredPresets = presetConditions.filter(presetElement => {
          const conditionsKeys = Object.keys(selectedConditions);
          for (let key of conditionsKeys) {
            if (selectedConditions[key] !== presetElement[key]) {
              return false;
            }
          }
          return true;
        })
        initialPresetId = (filteredPresets.length) ? filteredPresets[0].id : null;
        matchedPreset = (filteredPresets.length) ? presetValues[filteredPresets[0].id] : [];
        if (matchedPreset.length) {
          preset_container.querySelector('.profile-values-btn').classList.add('active');
        }
      }

      if(matchedPreset.length) {
        let btPlus = preset_container.querySelectorAll('.bt_plus:not(.auto)');
        if(btPlus){
          btPlus.forEach(btn => btn.classList.remove("disabled"));
        }
        let btMinus = preset_container.querySelectorAll('.bt_minus:not(.auto)');
        if(btMinus){
          btMinus.forEach(btn => btn.classList.remove("disabled"));
        }
        if (null !== initialPresetId) {
          preset_container.querySelector('#initialPresetId').value = initialPresetId;
        }

        matchedPreset.forEach(el => {
          const profileOptionField = preset_container.querySelector('.profile-option[data-optionname="'+ el.name +'"]');
          if (profileOptionField) {
            profileOptionField.value = el.value;
            profileOptionField.setAttribute("data-optionMin", el.value - 2);
            profileOptionField.setAttribute("data-optionMax", (+parseFloat(el.value.replace(/,/g, ".")).toFixed(2)) + 2);
            if(+profileOptionField.value == el.value - 2){
              profileOptionField.previousElementSibling.classList.add("disabled", "default-disabled");
            }
            if(+profileOptionField.value == +el.value + 2){
              profileOptionField.nextElementSibling.classList.add("disabled", "default-disabled");
            }
          }
        });
      }
    }

    const presetSelects = preset_container.querySelectorAll('.select-preset');
    if (presetSelects.length > 0) {
      presetSelects.forEach(select => select.addEventListener('change', fillPresetValues));
    }

    let formElement = document.querySelector('.measure-profile-popup.active #measurement-new-profile');
    formElement.addEventListener('change', () => formChanged = true);
    preset_container.querySelector('.reset-btn').addEventListener('click', resetValues);
    function resetValues(){
      preset_container.querySelectorAll('input.reset').forEach(el=>el.value = (el.getAttribute('data-optionmax') - 2));
      preset_container.querySelector('.reset-btn').classList.remove("active");
      preset_container.querySelectorAll('.bt_minus:not(.auto)').forEach(el=>el.classList.remove("disabled"));
      preset_container.querySelectorAll('.bt_plus:not(.auto)').forEach(el=>el.classList.remove("disabled"));
    };
    function formValidation(event){
      event.preventDefault();
      formElement.querySelectorAll('.validation-note-required').forEach(el=>el.classList.remove("active"));
      for(var i=0; i < formElement.elements.length; i++){
        var parent = findAncestor(formElement.elements[i], 'measurement-profile-value');
        if(parent){
          if(formElement.elements[i].value === '' && formElement.elements[i].hasAttribute('required')){
            parent.querySelector('.validation-note-required').classList.add("active");
            $this.scrollToError(parent);
            return false;
          }else if(formElement.elements[i].value === 'null' || formElement.elements[i].value === null){
            parent.querySelector('.validation-note-incorrect').classList.add("active");
            $this.scrollToError(parent);
            return false;
          }else if(parent.querySelector('.validation-note-range.active')){
            $this.scrollToError(parent);
            return false;
          }
        }
      }
      if(formElement.querySelectorAll('.validation-note.active').length > 0){
        return false;
      }else{
        let current_name = formElement.querySelector('.measurement-profile-name').value;
        if(!$this.profileNames.includes(current_name)){
          handler(event);
        }else{
          formElement.querySelector('.error-banner').innerText = "Duplicate Profile Name Alert, Please enter a new unique profile name!";
        }
      }
    };
    function handler(event) {
      event.preventDefault();
      formElement.querySelector('.form-submit').classList.add('loading');
      formElement.querySelector('.form-submit').setAttribute('disabled', true);
      formElement.querySelector('.error-banner').innerText = "";
      const formData = getFormJSON(formElement);
      formData['values'] = formData['values'].map((el) => ({'measurementId': el.id, 'value': el.value}));
      fetch('/apps/app-proxy/addCustomerMeasurementTypeProfile',
        {
          method: 'POST',
          body: JSON.stringify(formData)
        }
      ).then(response => response.json()).then(response => {
        if (response.success) {

          formChanged = false;
          $this.mergeNewProfiles(response);
        } else {
          formElement.querySelector('.error-banner').innerText = response.message;
          formElement.querySelector('.form-submit').classList.add('loading');
          formElement.querySelector('.form-submit').setAttribute('disabled', true);
        }
      });
    }
    formElement.querySelector('.form-submit').addEventListener('click', formValidation);

  }
  mergeNewProfiles(new_profile){
    formChanged = false;
    let storage_date = new Date();
    localStorage.removeItem("measurement-profiles");
    this.measurement_profiles.customerMeasurementProfiles.push(new_profile.measurementTypeProfile);
    this.measurement_profiles.profileNames.push(new_profile.measurementTypeProfile.name);
    this.measurement_profiles['date-created'] = '' + storage_date.getTime();
    localStorage.setItem('measurement-profiles', JSON.stringify(this.measurement_profiles));

    let url_path = (window.location.href).split('?')[0];
    window.location.href= url_path + '?line=' + this.line_id + '&ms_id=' + new_profile.measurementTypeProfile.id;
  }
  mergeEditProfiles(edit_profile){
    formChanged = false;
    let storage_date = new Date();
    localStorage.removeItem("measurement-profiles");
    let prof_index = this.measurement_profiles.customerMeasurementProfiles.findIndex(p => p.id == edit_profile.measurement_type_profile.id);
    let prof_name = this.measurement_profiles.customerMeasurementProfiles[prof_index].name;

    this.measurement_profiles.customerMeasurementProfiles[prof_index] = edit_profile.measurement_type_profile;
    this.measurement_profiles['date-created'] = '' + storage_date.getTime();
    if(prof_name != edit_profile.measurement_type_profile.name){
      let prof_name_index = this.measurement_profiles.profileNames.findIndex(p => p == prof_name);
      this.measurement_profiles.profileNames[prof_name_index] = edit_profile.measurement_type_profile.name;
    }
    localStorage.setItem('measurement-profiles', JSON.stringify(this.measurement_profiles));
    document.location.reload();

  }
  editProfileEvents(){
    formChanged = false;
    let $this = this;
    let formElement = document.querySelector('.measure-profile-popup.active #measurement-edit-profile');
    let inputs = formElement.querySelectorAll('.editable-text');
    for (let i = 0; i < inputs.length; i++) {
      inputs[i].addEventListener('change', this.tryToGuesstimate.bind(this), false);
    }
    const current_measure_id = formElement.parentElement.getAttribute('data-id');
    formElement.addEventListener('change', () => {
      formChanged = true;
    });
    formElement.querySelectorAll('.reset').forEach(el=>el.addEventListener('change', () => {
      formElement.querySelector('.reset-btn').classList.add("active");
    }));
    formElement.querySelector('.reset-btn').addEventListener('click', resetValues);
    function resetValues(){
      formElement.querySelectorAll('input.reset').forEach(el=>{
        el.value = el.getAttribute("data-value");
      });
      formElement.querySelectorAll('select').forEach(el=>{
        if(el.getAttribute("data-value")){
          el.value = el.getAttribute("data-value");
        }else if(el.querySelector('option.default')){
          el.value = el.querySelector('option.default').value;
        }else{
          el.selectedIndex = 0;
        }
      });
      formElement.querySelector('.reset-btn').classList.remove("active");
      formElement.querySelectorAll('.validation-note').forEach(el=>el.classList.remove("active"));
      formElement.querySelectorAll('.profile-value-header-note').forEach(el=>el.innerHTML = "");
    };
    let update_btn = formElement.querySelector('.update_form');
    let save_btn = formElement.querySelector('.save_form');

    if(update_btn){
      update_btn.addEventListener('click', (event) => {
        let valid = formValidation(event);
        if(valid){
          Update(event);
        }
      });
    }
    if(save_btn){
      save_btn.addEventListener('click', (event) => {
        event.preventDefault();
        let current_name = formElement.querySelector('.measurement-profile-name').value;
        if(!this.profileNames.includes(current_name)){
          let valid = formValidation(event);
          if(valid){
            saveAsNew(event);
          }
        }else{
          formElement.querySelector('.error-banner').innerText = "Duplicate Profile Name Alert, Please enter a new unique profile name!";
        }
      });
    }
    function formValidation(event){
      event.preventDefault();
      formElement.querySelectorAll('.validation-note-required').forEach(el=>el.classList.remove("active"));
      for(var i=0; i < formElement.elements.length; i++){
        var parent = findAncestor(formElement.elements[i], 'measurement-profile-value');
        if(parent){
          if(formElement.elements[i].value === '' && formElement.elements[i].hasAttribute('required')){
            parent.querySelector('.validation-note-required').classList.add("active");
            $this.scrollToError(parent);
            return false;
          }else if(formElement.elements[i].value === 'null' || formElement.elements[i].value === null){
            parent.querySelector('.validation-note-incorrect').classList.add("active");
            $this.scrollToError(parent);
            return false;
          }else if(parent.querySelector('.validation-note-range.active')){
            $this.scrollToError(parent);
            return false;
          }
        }
      }
      if(formElement.querySelectorAll('.validation-note.active').length > 0){
        return false;
      }else{
        return true;
      }
    };
    function  saveAsNew(event){
      event.stopPropagation();
      event.preventDefault();
      if(formElement.querySelectorAll('.validation-note.active').length > 0){
        return false;
      }
      save_btn.classList.add('loading');
      save_btn.setAttribute('disabled', true);
      update_btn.setAttribute('disabled', true);
      formElement.querySelector('.error-banner').innerText = "";
      const formData = getFormJSON(formElement);
      let newFormData = getFormJSON(formElement);
      newFormData['values'] = newFormData['values'].map((el) => ({'measurementId': el.id, 'value': el.value}));
      fetch('/apps/app-proxy/addCustomerMeasurementTypeProfile',
        {
          method: 'POST',
          body: JSON.stringify(newFormData)
        }
      ).then(response => response.json()).then(response => {
        if (response.success) {
          formChanged = false;
          $this.mergeNewProfiles(response);
        } else {
          save_btn.classList.remove('loading');
          save_btn.removeAttribute('disabled');
          update_btn.removeAttribute('disabled');
          formElement.querySelector('.error-banner').innerText = response.message;
        }
      });
    };

    function Update(event){
      event.stopPropagation();
      event.preventDefault();
      if(formElement.querySelectorAll('.validation-note.active').length > 0){
        return false;
      }
      update_btn.classList.add('loading');
      update_btn.setAttribute('disabled', true);
      save_btn.setAttribute('disabled', true);
      formElement.querySelector('.error-banner').innerText = "";

      let formData = getFormJSON(formElement);
      formData['values'] = formData['values'].map((el) => ({'measurementId': el.id, 'value': el.value}))
      fetch('/apps/app-proxy/updateMeasurementTypeProfile',
        {
          method: 'POST',
          body: JSON.stringify(formData)
        }
      ).then(response => response.json()).then(response => {
        if (response.success) {
          formChanged = false;
          let updatet_prof = response;
          let updated_ms = response.measurement_type_profile.values;
          let new_ms_price = response.measurement_type_profile.profileAdditionalPrice;
          let options_additional_price = 0;
          fetch(window.Shopify.routes.root + 'cart.js')
            .then(response => response.json())
            .then(data => {
              let items_for_update = [];
              data.items.forEach((item, i) => {
                if(item.properties){
                  let measure_id = item.properties["_ms-id"];
                  let item_prop;
                  let quantity;
                  let line;
                  let propObj = item.properties;
                  if(measure_id && measure_id == current_measure_id ){
                    item_prop = item.properties;
                    quantity = item.quantity;
                    line = i+1;
                    updated_ms.forEach(function(key) {
                      let price = key.valueAdditionalPrice > 0 ? ` ($${key.valueAdditionalPrice})` : ''
                      propObj["_ms_name_" + key.measurement.name] = key.value + price;
                      propObj[key.measurement.name] = key.value + price;
                    });
                    if(item.properties["_options_additional_price"]){
                      options_additional_price = item.properties["_options_additional_price"];
                    }
                    propObj['_measurements_additional_price'] = new_ms_price;
                    propObj['_total_additional_price'] = +options_additional_price + new_ms_price;
                    const body = JSON.stringify({
                      line,
                      quantity,
                      properties: propObj
                    });
                    items_for_update.push(body);
                  }

                }
              })
              let count = 0;
              if(items_for_update.length > 0){
                function changeMeasure(count){
                  let body = items_for_update[count];
                  if(body){
                    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }}).then((response) => {
                      count++;
                      changeMeasure(count);
                    })
                  }else{
                    $this.mergeEditProfiles(updatet_prof);
                  }
                }
                changeMeasure(count);
              }else{
                $this.mergeEditProfiles(updatet_prof);
              }
            });
        } else {
          update_btn.classList.remove('loading');
          update_btn.removeAttribute('disabled');
          save_btn.removeAttribute('disabled');
          formElement.querySelector('.error-banner').innerText = response.message;
        }
      });
    }
  }
  editPresetsProfileEvents(){
    formChanged = false;
    let $this = this;
    let formElement = document.querySelector('.measure-profile-popup.active #measurement-edit-profile');
    let current_measure_id = formElement.parentElement.getAttribute('data-id');
    formElement.addEventListener('change', () => formChanged = true);
    formElement.querySelector('.reset-btn').addEventListener('click', resetValues);
    function resetValues(){
      formElement.querySelectorAll('input.reset').forEach(el=>el.value = el.getAttribute('data-value'));
      formElement.querySelector('.reset-btn').classList.remove("active");
      formElement.querySelectorAll('.bt_minus:not(.auto)').forEach(el=>el.classList.remove("disabled"));
      formElement.querySelectorAll('.bt_plus:not(.auto)').forEach(el=>el.classList.remove("disabled"));
      formElement.querySelectorAll('.bt_minus.default-disabled').forEach(el=>el.classList.add("disabled"));
      formElement.querySelectorAll('.bt_plus.default-disabled').forEach(el=>el.classList.add("disabled"));
    };
    let update_btn = formElement.querySelector('.update_form');
    let save_btn = formElement.querySelector('.save_form');

    if(update_btn){
      update_btn.addEventListener('click', (event) => {
        let valid = formValidation(event);
        if(valid){
          Update(event);
        }
      });
    }
    if(save_btn){
      save_btn.addEventListener('click', (event) => {
        event.preventDefault();
        let current_name = formElement.querySelector('.measurement-profile-name').value;
        if(!this.profileNames.includes(current_name)){
          let valid = formValidation(event);
          if(valid){
            saveAsNew(event);
          }
        }else{
          formElement.querySelector('.error-banner').innerText = "Duplicate Profile Name Alert, Please enter a new unique profile name!";
        }
      });
    }
    function formValidation(event){
      event.preventDefault();
      formElement.querySelectorAll('.validation-note-required').forEach(el=>el.classList.remove("active"));
      for(var i=0; i < formElement.elements.length; i++){
        if(formElement.elements[i].value === '0' && formElement.elements[i].hasAttribute('required') && formElement.elements[i].dataset.optiontype != 'text' ||
          formElement.elements[i].value === '' && formElement.elements[i].hasAttribute('required') && formElement.elements[i].dataset.optiontype == 'text' ||
          formElement.elements[i].value === '' && formElement.elements[i].hasAttribute('required') && formElement.elements[i].dataset.optiontype == 'dropdown'
        ){
          var parent = findAncestor(formElement.elements[i], 'measurement-profile-value');
          parent.querySelector('.validation-note-required').classList.add("active");
          $this.scrollToError(parent);
          return false;
        }else if(formElement.elements[i].value === 'null' || formElement.elements[i].value === null){
          var parent = findAncestor(formElement.elements[i], 'measurement-profile-value');
          parent.querySelector('.validation-note-incorrect').classList.add("active");
          $this.scrollToError(parent);
          return false;
        }
      }
      if(formElement.querySelectorAll('.validation-note.active').length > 0){
        return false;
      }else{
        return true;
      }
    };
    function  saveAsNew(event){
      event.stopPropagation();
      event.preventDefault();
      save_btn.classList.add('loading');
      save_btn.setAttribute('disabled', true);
      update_btn.setAttribute('disabled', true);
      formElement.querySelector('.error-banner').innerText = "";
      const formData = getFormJSON(formElement);
      let newFormData = getFormJSON(formElement);
      newFormData['values'] = newFormData['values'].map((el) => ({'measurementId': el.id, 'value': el.value}));
      fetch('/apps/app-proxy/addCustomerMeasurementTypeProfile',
        {
          method: 'POST',
          body: JSON.stringify(newFormData)
        }
      ).then(response => response.json()).then(response => {
        if (response.success) {
          formChanged = false;
          $this.mergeNewProfiles(response);
        } else {
          save_btn.classList.remove('loading');
          save_btn.removeAttribute('disabled');
          update_btn.removeAttribute('disabled');
          formElement.querySelector('.error-banner').innerText = response.message;
        }
      });
    };

    function Update(event){
      event.stopPropagation();
      event.preventDefault();
      update_btn.classList.add('loading');
      update_btn.setAttribute('disabled', true);
      save_btn.setAttribute('disabled', true);
      formElement.querySelector('.error-banner').innerText = "";
      let new_ms_price;
      let options_additional_price = 0;
      let formData = getFormJSON(formElement);
      formData['values'] = formData['values'].map((el) => ({'measurementId': el.id, 'value': el.value}));
      fetch('/apps/app-proxy/updateMeasurementTypeProfile',
        {
          method: 'POST',
          body: JSON.stringify(formData)
        }
      ).then(response => response.json()).then(response => {
        if (response.success) {
          formChanged = false;
          new_ms_price = response.measurement_type_profile.profileAdditionalPrice;
          let updatet_prof = response;
          let updated_ms = response.measurement_type_profile.values;
          fetch(window.Shopify.routes.root + 'cart.js')
            .then(response => response.json())
            .then(data => {
              let items_for_update = [];
              data.items.forEach((item, i) => {
                if(item.properties){
                  let measure_id = item.properties["_ms-id"];
                  let item_prop;
                  let quantity;
                  let line;
                  let propObj = item.properties;
                  if(measure_id && measure_id == current_measure_id ){
                    item_prop = item.properties;
                    quantity = item.quantity;
                    line = i+1;
                    updated_ms.forEach(function(key) {
                      propObj["_ms_name_" + key.measurement.name] = key.value;
                    });
                    if(item.properties["_options_additional_price"]){
                      options_additional_price = +item.properties["_options_additional_price"];
                    }
                    propObj['_measurements_additional_price'] = new_ms_price;
                    propObj['_total_additional_price'] = options_additional_price + new_ms_price;
                    const body = JSON.stringify({
                      line,
                      quantity,
                      properties: propObj
                    });
                    items_for_update.push(body);
                  }

                }
              })
              let count = 0;
              if(items_for_update.length > 0){
                function changeMeasure(count){
                  let body = items_for_update[count];
                  if(body){
                    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }}).then((response) => {
                      count++;
                      changeMeasure(count);
                    })
                  }else{
                    $this.mergeEditProfiles(updatet_prof);
                  }
                }
                changeMeasure(count);
              }else{
                $this.mergeEditProfiles(updatet_prof);
              }
            });
        } else {
          update_btn.classList.remove('loading');
          update_btn.removeAttribute('disabled');
          save_btn.removeAttribute('disabled');
          formElement.querySelector('.error-banner').innerText = response.message;
        }
      });
    }
  }
  tryToGuesstimate (el) {
    let formElement = document.querySelector('.measure-profile-popup.active');
    formElement.querySelectorAll('.profile-value-header-note').forEach(el=>el.innerHTML = "");
    formElement.querySelectorAll('.editable-text').forEach(option=> {
      const guesstimated = this.guesstimates.find(el => el.measurementName === option.getAttribute('data-optionname') && el.measurementValue === option.value);
      if(guesstimated !== undefined || guesstimated != null){
        guesstimated.guesstimatedMeasurements.forEach(el => {
          let note_el = formElement.querySelector('.profile-value-header-note[data-optionname="'+ el.guesstimatedMeasurementName +'"]');
          if(note_el){
            note_el.innerHTML = "Guesstimated "+ el.guesstimatedMeasurementValue + " in";
          }
        });
      }

    });

  };
  minusValues(ev){
    let editForm = document.querySelector('.measure-profile-popup.active');
    if (ev.target.classList.contains('disabled')) {
      return;
    }
    editForm.querySelector('.reset-btn').classList.add("active");
    let cur_input = ev.target.parentElement.querySelector('input');
    let max = parseFloat(cur_input.getAttribute('data-optionmax'));
    let min = parseFloat(cur_input.getAttribute('data-optionmin'));
    let count = parseFloat(cur_input.value) - 0.25;
    let optionname = cur_input.getAttribute('data-optionname');
    if (count < min){
      return;
    }else{
      count = count < 0 ? 0 : count;
    }

    if(count - 0.25  < min){
      ev.target.classList.add("disabled");
    }
    if(count < max){
      ev.target.parentElement.querySelector('.bt_plus').classList.remove("disabled");
    }
    if(count){
      cur_input.value = count;
      if(optionname == 'Inseam'){
        editForm.querySelector('input[data-optionname="Outseam (auto)"]').value = (+count.toFixed(2)) + 10;
      }
      let evt = document.createEvent("HTMLEvents");
      evt.initEvent("change", false, true);
      cur_input.dispatchEvent(evt);
      editForm.querySelector('.profile-form').dispatchEvent(evt);
    }
  }
  plusValues(ev){
    if (ev.target.classList.contains('disabled')) {
      return;
    }
    let editForm = document.querySelector('.measure-profile-popup.active');
    editForm.querySelector('.reset-btn').classList.add("active");
    let cur_input = ev.target.parentElement.querySelector('input');
    let max = parseFloat(cur_input.getAttribute('data-optionmax'));
    let min = parseFloat(cur_input.getAttribute('data-optionmin'));
    let count;
    if(parseFloat(cur_input.value) == 0){
      count = min;
    }else{
      count = parseFloat(cur_input.value) + 0.25;
    }
    let optionname = cur_input.getAttribute('data-optionname');
    if (count > max){
      return;
    }
    if(count + 0.25  > max){
      ev.target.classList.add("disabled");
    }
    if(count > min){
      ev.target.parentElement.querySelector('.bt_minus ').classList.remove("disabled");
    }
    if(count){
      cur_input.value = count;
      if(optionname == 'Inseam'){
        editForm.querySelector('input[data-optionname="Outseam (auto)"]').value = (+count.toFixed(2)) + 10;
      }
      let evt = document.createEvent("HTMLEvents");
      evt.initEvent("change", false, true);
      cur_input.dispatchEvent(evt);
      editForm.querySelector('.profile-form').dispatchEvent(evt);
    }

  }
  onInputValid(ev){
    let _this = ev.target;
    let min = parseInt(_this.getAttribute('data-optionmin'));
    let max = parseInt(_this.getAttribute('data-optionmax'));
    let val = +parseFloat(_this.value.replace(/,/g, ".")).toFixed(2);
    let note = ev.target.parentElement.nextElementSibling.querySelector(".validation-note-range");
    if(!isNaN(val) && note){
      let decimalpoint = parseInt(_this.getAttribute('data-optiondecimalpoint'));
      if (min || max){
        if (val < min || val > max){
          note.classList.add("active");
        }else{
          note.classList.remove("active");
        }
      }
      if(decimalpoint){
        let numToRoundTo = 1/ (decimalpoint / 100);
        val = Math.round(val * numToRoundTo) / numToRoundTo;
      }
      _this.value = val;
    }

  }
  closePopup(ev) {
    /*ev.preventDefault();
    document.querySelector('.add-measurement-profile-wrap.active').classList.remove("active");
    this.bodyRemoveFixed();*/

    ev.preventDefault();
    const popup = document.querySelector('.add-measurement-profile-wrap.active');
    if (popup) {
      popup.classList.remove('active');
      const select = popup.closest('.item__btn_select');
      if (select) {
        select.classList.add('active');
      }
    }
    this.bodyRemoveFixed();
  };
  converterCmtoInch(e){
    let value = Number(e.currentTarget.value);
    if (value > 0){
      let converter = value * 0.39370078740157;
      let rounding = (Math.round(converter * 4) / 4 ).toFixed(2);
      this.resaultArea.innerHTML = rounding;
      this.resaultArea.classList.add("active");
    } else {
      this.resaultArea.innerHTML = "INCH";
      this.resaultArea.classList.remove("active");
      return
    }
  };
  isNumber(n) { return !isNaN(parseFloat(n)) && !isNaN(n - 0) }
  checkTabPress(e) {
    if(window.innerWidth > 990){
      "use strict";
      e = e || event;
      var activeElement;
      if (e.keyCode == 9) {
        // Here read the active selected link.
        activeElement = document.activeElement;
        // If HTML element is an anchor <a>
        if (activeElement.classList.contains('profile-option')){
          this.openDefinitionPopup(findAncestor(activeElement, 'profile-value-content'));
        }
      }
    }
  }
  convertHeight(){
    let editForm = document.querySelector('.measure-profile-popup.active');
    let height_ft = +editForm.querySelector('#height-ft').value;
    if(!this.isNumber(height_ft)){
      height_ft = 0;
    }
    let height_in = +editForm.querySelector('#height-in').value;
    if(!this.isNumber(height_in)){
      height_in = 0;
    }

    let cur_height = (height_ft *12)+height_in;
    editForm.querySelector('.measurement-profile-value[data-value-type="Height"] input').value = cur_height;
    var event = new Event('change');
    editForm.querySelector('.measurement-profile-value[data-value-type="Height"] input').dispatchEvent(event);
  }
  openSelect(e){
    e.preventDefault();

    const currentBtn = e.currentTarget;
    const cartItems = currentBtn.closest('.cart-items');
    if (cartItems) {
      cartItems.querySelectorAll('.item__measurement-btn.active').forEach(btn => {
        if (btn !== currentBtn) {
          btn.classList.remove('active');
        }
      });
    }

    e.currentTarget.parentElement.classList.toggle('active');
  }
  openDefinitionPopup(element) {
    let editForm = document.querySelector('.measure-profile-popup.active');
    let option_type = false;
    if(window.innerWidth < 991){
      if(element.classList.contains('info-block')){
        option_type = element.parentElement.querySelector('.profile-option').getAttribute('data-optionname');
      }
    }else{
      if(element.classList.contains('profile-value-content')){
        option_type = element.parentElement.querySelector('.profile-option').getAttribute('data-optionname');
      }
    }

    if(option_type){
      editForm.querySelectorAll('.definition-wrap').forEach(el=>el.classList.remove("active"));
      editForm.querySelectorAll('.definition-wrap[data-option-type="'+ option_type +'"]').forEach(el=>el.classList.add("active"));
      if(window.innerWidth < 991){
        editForm.querySelector('.profile-values-definition-wrap .profile-values-definition').style.top = `calc(${document.querySelector('.measure-profile-popup.active').scrollTop}px + 50%)`;
        editForm.classList.add("info");
        editForm.querySelector('.profile-values-definition-wrap').classList.add("active");
      }
    }
  }
  remove(event){
    event.preventDefault();
    document.querySelector('.popup-mask').classList.add('active');
    event.currentTarget.nextElementSibling.classList.add('active');
  }
  bodyFixed(){
    document.body.style.top = `-${window.scrollY}px`;
    document.body.classList.add('fixed');
  }
  bodyRemoveFixed(){
    let bodyScrollY = parseInt(document.body.style.getPropertyValue('top'), 10);
    bodyScrollY = Math.abs(bodyScrollY);
    document.body.classList.remove("fixed");
    document.body.style.top = null;
    window.scrollTo(0, bodyScrollY);
  }
  showPopup(){
    document.querySelector('.measure-popup-mask').classList.add('active');
    this.bodyFixed();
  }
  scrollToError(el){
    let current_popup = document.querySelector('.measure-profile-popup.active');
    if(el.querySelector('input.profile-option')){
      el.querySelector('input.profile-option').focus();
    }
    if (current_popup.scrollTop > el.offsetTop) {
      current_popup.scrollTo({top: el.offsetTop, behavior: 'smooth'});
    }
  }
}

function getFormJSON(form) {
  const data = new FormData(form);
  return Array.from(data.keys()).reduce((result, key) => {
    if (key.includes('[]')) {
      //it is array, convert key to array result
      const [arrKey, arrValue] = key.split('[]');
      const valueObj = {
        'id': arrValue.replace(/[\[|\]]/g,''),
        'value': data.get(key)
      };
      if (arrKey in result) {
        result[arrKey].push(valueObj);
      } else {
        result[arrKey] = [valueObj];
      }
    } else {
      result[key] = data.get(key);
    }
    return result;
  }, {});
}
function isNumberKey(evt){
  var charCode = (evt.which) ? evt.which : event.keyCode
  if( (charCode > 47 && charCode <58) || charCode == 46 )
    return true;
  else
    return false;
}
function findAncestor (el, cls) {
  while ((el = el.parentElement) && !el.classList.contains(cls));
  return el;
}
function checkQuote() {
  if(event.target.classList.contains('measurement-profile-name')){
    if(event.keyCode == 34 || event.keyCode == 32) {
      event.keyCode = 0;
      return false;
    }
  }else{
    if(event.keyCode == 34) {
      event.keyCode = 0;
      return false;
    }
  }
}
